import {
  FieldErrors,
  FieldValues,
  Path,
  UseFormRegister,
} from "react-hook-form";
import { TextInput } from "@normasteaching/norma-ui";
import { BusinessType } from "../MoneyTransfer/BusinessType.tsx";
import type { BillingFormFields } from "./BillingFormSection.tsx";

function FieldLabel({ children }: { children: string }) {
  return (
    <label className="block text-md font-bold text-gray-900 mb-2">
      {children}
    </label>
  );
}

export function ForeignBillingFields<
  T extends FieldValues & BillingFormFields,
>({
  register,
  errors,
  businessType,
}: {
  register: UseFormRegister<T>;
  errors: FieldErrors<BillingFormFields>;
  businessType?: string;
}) {
  return (
    <div className="space-y-6">
      <div className="bg-blue-50 p-4 rounded-lg">
        <p className="text-sm text-blue-800 font-medium">
          Inserire l'identificativo fiscale.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <FieldLabel>Tax ID / Partita IVA estera</FieldLabel>
          <TextInput
            {...register("vat" as Path<T>)}
            errorMessage={errors.vat?.message}
            placeholder="Es. DE123456789"
          />
        </div>

        {businessType === BusinessType.Company && (
          <div>
            <FieldLabel>Ragione Sociale</FieldLabel>
            <TextInput
              {...register("businessName" as Path<T>)}
              errorMessage={errors.businessName?.message}
              placeholder="Inserire ragione sociale"
            />
          </div>
        )}

        <div>
          <FieldLabel>Indirizzo</FieldLabel>
          <TextInput
            {...register("address.street" as Path<T>)}
            errorMessage={errors.address?.street?.message}
            placeholder="Via e numero civico"
          />
        </div>

        <div>
          <FieldLabel>Codice postale</FieldLabel>
          <TextInput
            {...register("address.cap" as Path<T>)}
            errorMessage={errors.address?.cap?.message}
            placeholder="Codice postale (se previsto)"
          />
        </div>

        <div>
          <FieldLabel>Città</FieldLabel>
          <TextInput
            {...register("address.city" as Path<T>)}
            errorMessage={errors.address?.city?.message}
            placeholder="Città"
          />
        </div>

        <div>
          <FieldLabel>Provincia / Stato / Regione</FieldLabel>
          <TextInput
            {...register("address.province" as Path<T>)}
            errorMessage={errors.address?.province?.message}
            placeholder="Facoltativo"
          />
        </div>
      </div>
    </div>
  );
}
